/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  fill?: string;
};

const SvgComponent: FC<IProps> = ({ width = 40, height = 24, fill = "none" }) => (
  <svg
    width={width}
    height={height}
    viewBox="8 4 400 360"
    className="border border-gray-300 rounded-lg"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <linearGradient id="a" x1="148.19" y1="270.12" x2="213.35" y2="270.12" gradientTransform="matrix(2.05, 0, 0, -2.05, -4.47, 736.29)" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#007940" />
        <stop offset="0.23" stopColor="#00873f" />
        <stop offset="0.74" stopColor="#40a737" />
        <stop offset="1" stopColor="#5cb531" />
      </linearGradient>
      <linearGradient id="b" x1="148.18" y1="280.2" x2="213.29" y2="280.2" xlinkHref="#a" />
      <linearGradient id="c" x1="148.18" y1="291.29" x2="213.35" y2="291.29" xlinkHref="#a" />
      <linearGradient id="d" x1="2.3" y1="280.27" x2="68.47" y2="280.27" gradientTransform="matrix(2.05, 0, 0, -2.05, -4.47, 736.29)" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#1f286f" />
        <stop offset="0.48" stopColor="#004e94" />
        <stop offset="0.83" stopColor="#0066b1" />
        <stop offset="1" stopColor="#006fbc" />
      </linearGradient>
      <linearGradient id="e" x1="74.89" y1="280.13" x2="139.16" y2="280.13" gradientTransform="matrix(2.05, 0, 0, -2.05, -4.47, 736.29)" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#6c2c2f" />
        <stop offset="0.17" stopColor="#882730" />
        <stop offset="0.57" stopColor="#be1833" />
        <stop offset="0.86" stopColor="#dc0436" />
        <stop offset="1" stopColor="#e60039" />
      </linearGradient>
    </defs>
    <path fill="url(#a)" d="M325.69,197h31.2c.89,0,3-.3,3.86-.3a13.92,13.92,0,0,0,11-14,14.41,14.41,0,0,0-11-14,15.52,15.52,0,0,0-3.86-.3h-31.2V197Z" />
    <path fill="url(#b)" d="M353.32,0a54.09,54.09,0,0,0-54.08,54.08v56.17h76.37a31.36,31.36,0,0,1,5.35.29c17.24.9,30,9.81,30,25.26,0,12.19-8.61,22.59-24.66,24.67v.59c17.53,1.19,30.9,11,30.9,26.15,0,16.35-14.85,27-34.47,27h-83.8v110h79.35a54.09,54.09,0,0,0,54.08-54.08V0Z" />
    <path fill="url(#c)" d="M367.89,139.37a12.65,12.65,0,0,0-11-12.78c-.59,0-2.08-.3-3-.3H325.69v26.15h28.23c.89,0,2.67,0,3-.29A12.66,12.66,0,0,0,367.89,139.37Z" />
    <path fill="url(#d)" d="M54.38,0A54.08,54.08,0,0,0,.3,54.08V187.51c15.15,7.43,30.9,12.18,46.65,12.18,18.72,0,28.83-11.29,28.83-26.74V110h46.35v62.7c0,24.37-15.15,44.28-66.56,44.28A228,228,0,0,1,0,210.09V323.91H79.34a54.09,54.09,0,0,0,54.09-54.09V0Z" />
    <path fill="url(#e)" d="M203.85,0a54.09,54.09,0,0,0-54.08,54.08v70.73c13.67-11.59,37.44-19,75.78-17.24,20.5.89,42.49,6.54,42.49,6.54V137c-11-5.64-24.07-10.7-41-11.89-29.12-2.08-46.65,12.19-46.65,37.15,0,25.26,17.53,39.52,46.65,37.14,16.94-1.18,30-6.53,41-11.88v22.88s-21.69,5.65-42.49,6.54c-38.34,1.78-62.11-5.65-75.78-17.24V324.5h79.34a54.08,54.08,0,0,0,54.08-54.08V0Z" />
  </svg>
);

export default SvgComponent;
